// extracted by mini-css-extract-plugin
module.exports = {"container":"Alert_container__2QLR-","text":"Alert_text__2OFPk"};